module.exports = __webpack_public_path__ + "img/arrow-right-orange.cb7fe51e.svg";